"use client";

import { useEffect } from "react";
import { useAnalytics } from "@/lib/analytics/client";
import { trackClientEvent } from "@/lib/analytics/events";
import type { AnalyticsEventProps } from "@/lib/analytics/types";

export default function TrackEvent({
  event,
  props,
}: {
  event: string;
  props?: AnalyticsEventProps;
}) {
  const analytics = useAnalytics();

  useEffect(() => {
    trackClientEvent(analytics, event, props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analytics, event]);

  return null;
}
